import React from 'react';

const AccountContext = React.createContext({
	loggedIn : localStorage.getItem("publicKycLogin") ? true : false,
	setLoggedIn: () => {}
});

export default AccountContext;